module.exports = __webpack_public_path__ + "img/ep7-3.675a5d45.png";